import React, { useState } from 'react';
import styles from './M_FAQAccordionItem.module.css';
import { Q_Icon } from '@/components/Q_Quarks/Q_Icon/Q_Icon';
import cn from 'classnames';

export interface M_FAQAccordionItemProps {
  title: string;
  description: string;
}

export default function M_FAQAccordionItem({
  title,
  description,
}: M_FAQAccordionItemProps) {
  const [isOpened, setIsOpened] = useState(false);
  return (
    <div className={cn(styles.wrapper, { [styles.opened]: isOpened })}>
      <div
        className={styles.accordion_wrapper}
        onClick={() => setIsOpened(!isOpened)}
        role='button'
        aria-expanded={isOpened}
        aria-label={isOpened ? 'Свернуть' : 'Развернуть'}
      >
        <p className={cn(styles.title, 'text-p-4')}>{title}</p>
        <div
          className={cn(styles.arrow_wrapper, { [styles.arrow_up]: isOpened })}
        >
          <Q_Icon.AccordionArrowIcon width={16} height={16} fill='none' />
        </div>
      </div>
      {isOpened && (
        <div className={styles.accordion_content}>
          <p className={cn(styles.description, 'text-p-7')}>{description}</p>
        </div>
      )}
    </div>
  );
}
